export default "./img/img-701dd7.png";